import { getAuthToken } from "@store/auth/cookieStorage";
import { InternalAxiosRequestConfig } from "axios";
import qs from "qs";

export default function requestInterceptor(config: InternalAxiosRequestConfig) {

  if (process.env.NODE_ENV === "development") {
    const token = getAuthToken();
    if (token) {
      config.headers!["Authorization"] = `Bearer ${token}`;
    }
  }
  if (config.headers['Content-Type'] !== 'application/json') {
    if (config.method === "post" || config.method === "put") {
      if (!(config.data instanceof FormData)) {
        if (!(typeof config.data === "string")) {
          //console.log("AXIOS", config.headers);
          config.data = qs.stringify(config.data);
        }
      }
    }
  }
  return { ...config };
}